export const MARKETO = {
  FORM_URL: '//app-ab31.marketo.com',
  MUNCHKIN_COOKIE: '_mkto_trk',
  UTM_COOKIE: '_fs_utm',
};

export const API_ROUTES = {
  REQUEST_DEMO: '/.netlify/functions/request_demo',
  CREATE_LEAD: '/.netlify/functions/create_lead',
  SIGNUP: '/.netlify/functions/signup',
};
